import React from 'react';
export default React.createElement("svg", {
  width: "4px",
  height: "16px",
  viewBox: "0 0 4 16",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, React.createElement("title", null, "Action Menu Button"), React.createElement("desc", null, "Created with Sketch."), React.createElement("defs", null), React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Icons-/-action-menu-button",
  transform: "translate(-12.000000, -6.000000)",
  fill: "currentColor"
}, React.createElement("g", {
  id: "Group-6",
  transform: "translate(12.000000, 6.000000)"
}, React.createElement("circle", {
  id: "Oval-4",
  cx: "2",
  cy: "2",
  r: "2"
}), React.createElement("circle", {
  id: "Oval-4",
  cx: "2",
  cy: "8",
  r: "2"
}), React.createElement("circle", {
  id: "Oval-4",
  cx: "2",
  cy: "14",
  r: "2"
})))));